import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { EnrollmentInput } from '../../../../lib/types/models/enrollment/enrollment-input'
import { BaseFormProps, NullableTransformer } from '../../../../lib/types/utils'
import { getSubmitAction } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { createStringSchema } from '../../../../lib/utils/validations/string-validation'
import { FORM_MODE } from '../../../../utils/constants/form.constants'
import { Form } from '../../../elements/forms/form'
import ValidationButtons from '../../../elements/validation-buttons'
import AddressEnrollmentForm from '../../enrollments/enrollment-form/address-enrollment-form'

export type AddressInformationInput = Pick<
  EnrollmentInput,
  'address1' | 'address2' | 'city' | 'postalCode' | 'country'
>

export const ADDRESS_INFORMATION_SCHEMA = z.object({
  address1: createStringSchema('Adresse'),
  address2: createStringSchema(`Complément d'adresse`, { nullish: true }),
  city: createStringSchema('Ville'),
  postalCode: createStringSchema('Code postal'),
  country: createStringSchema('Pays')
})

export const ADDRESS_INFORMATION_SCHEMA_TYPED: ZodType<
  NullableTransformer<AddressInformationInput>
> = ADDRESS_INFORMATION_SCHEMA

const AddressInformationForm = ({
  defaultValues,
  className,
  ...validationButtonProps
}: BaseFormProps<AddressInformationInput, true>) => {
  const form = useForm<AddressInformationInput>({
    resolver: zodResolver(ADDRESS_INFORMATION_SCHEMA_TYPED),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={className}>
          <AddressEnrollmentForm />
        </div>
        <ValidationButtons hasBorderTop {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default AddressInformationForm
